class ModalHandler {
  constructor() {
    this.currentModal = null;
    this.savedScrollY = 0;
    this.init();
    this.observeDOM();
  }

  init() {
    document.querySelectorAll('.modal-link:not([data-modal-init])').forEach((link) => {
      link.setAttribute('data-modal-init', 'true');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const modalId = link.getAttribute('data-modal-id');
        this.showModal(modalId);
      });
    });

    // Modal overlay click
    document.querySelectorAll('.modal-window-overlay:not([data-modal-init])').forEach((modal) => {
      modal.setAttribute('data-modal-init', 'true');
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          this.hideModal(modal.id);
        }
      });
    });

    // NEW: ensure placement immediately when modal appears in DOM
    document
      .querySelectorAll('.modal-window-overlay[data-placement="body"]:not([data-placement-applied])')
      .forEach((modal) => {
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
        modal.setAttribute('data-placement-applied', 'true');
      });
  }

  observeDOM() {
    const observer = new MutationObserver(() => this.init());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  lockScroll() {
    this.savedScrollY = window.scrollY;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.savedScrollY}px`;
    document.body.style.width = '100%';
    document.body.style.paddingRight = scrollbarWidth + 'px';
  }

  unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
    window.scrollTo(0, this.savedScrollY);
  }

  showModal(modalId) {
    if (!modalId) return;
    let modal = document.getElementById(modalId);
    if (!modal) return;

    this.lockScroll();

    modal.classList.add('show');
    document.body.classList.add('modal-opened');
    document.documentElement.classList.add('modal-opened');

    this.currentModal = modal;
  }

  hideModal(modalId) {
    if (!modalId) return;
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.remove('show');
      if (this.currentModal === modal) {
        this.currentModal = null;
      }
    }
    document.body.classList.remove('modal-opened');
    document.documentElement.classList.remove('modal-opened');

    this.unlockScroll();
  }

  closeCurrentModal() {
    if (this.currentModal) {
      this.currentModal.classList.remove('show');
      this.currentModal = null;
    }
    document.body.classList.remove('modal-opened');
    document.documentElement.classList.remove('modal-opened');
    this.unlockScroll();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.modalHandler = new ModalHandler();
});
